import RadioButtonGroupExample from "./examples/RadioButton.Example";

export default [
    {
        title: "Basic radio buttons",
        component: RadioButtonGroupExample,
        code: require("!raw-loader!./examples/RadioButton.Example.tsx")
    }
];
